
import React, { JSX } from "react";

type LanguageCode = "en" | "pt" | "es" | "fr" | "de";

interface Language {
  code: LanguageCode;
  label: string;
  flag: string;
}

interface LanguageDropdownProps {
}


const LANGUAGES: Language[] = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "pt", label: "Português", flag: "🇧🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

function LanguageDropdown({ }: LanguageDropdownProps): JSX.Element {
  const [open, setOpen] = React.useState<boolean>(false);
  const ref = React.useRef<HTMLDivElement>(null);
  const [currentLang, setCurrentLang] = React.useState<Language>(LANGUAGES[0]);

  React.useEffect(() => {
    const handler = (e: MouseEvent): void => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  if (true) {
    return <></>;
  }

  return (
    <div className="dropdown-wrap" ref={ref}>
      <button className="lang-btn" onClick={() => setOpen((v: boolean) => !v)}>
        <span>{currentLang.flag}</span>
        <span>{currentLang.code.toUpperCase()}</span>
        <span className={`caret${open ? " open" : ""}`}>▾</span>
      </button>
      {open && (
        <div className="dropdown lang-dropdown">
          {LANGUAGES.map((lang: Language) => (
            <button
              key={lang.code}
              className={`dd-item${lang.code === currentLang.code ? " lang-active" : ""}`}
              onClick={() => { setCurrentLang(lang); setOpen(false); }}
            >
              <span className="lang-option">
                <span className="flag">{lang.flag}</span>
                <span className="lang-name">{lang.label}</span>
                <span className="lang-code">{lang.code.toUpperCase()}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageDropdown;
